import React from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { camelCase } from "lodash";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
// import RedCircle from '../../src/images/redcircle.png';
import redcircle from "../../src/images/redcircle.png";
import next from "../../src/images/next.svg";
import SvgIcon from "@material-ui/core/SvgIcon";

const styles = (theme) => ({
  root: {
    marginBottom: "6px",
  },
  card: {
    maxWidth: 345,
    width: 300,
    marginBottom: "12px",
    marginRight: "12px",
    borderColor:'#B71C1C',
    border:'1px solid',
  },
});

var show = {display:'block'}
var hide = {display:'none'}
var v = show



const Arbitrator = (props) => {
  const { classes } = props;
//   console.log("in Arbitrator props: " + JSON.stringify(props));
  // console.log('in Arbitrator lang: '+JSON.stringify(props.lang))
  // var lang = localStorage.getItem('language');
  var lang = localStorage.getItem("language");
  console.log('in Arbitrator lang: '+lang)
  if (lang == "en") {
    return (
      <Card className={classes.card}>
        <CardContent>
        <img style={{width:'30px', float:'right'}} src={redcircle}></img>
          <Typography style={{fontWeight:'bold'}}>
            {props.lastName + " " + props.firstName}
          </Typography>
          <br></br>
          <Typography>
            <a target="_blank" style={{color:'black', float:'right'}}  href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${props.arbitratorId}`} >{props.arbitratorProfile}</a>
          </Typography>
          {/* <Typography onClick={()=>{v = show}} style={{float:'right', marginRight: '-40px', marginTop: '20px', fontSize:'10px', color:'#B71C1C', fontWeight:'bold'}}>
              {props.arbitratorProfile} <img style={{width:'10px'}} src={next}></img>
          </Typography> */}
          {/* <br></br>
          <div style={v}>
            <Typography>
                {props.jurisdictions}: {props.jurisdiction}
            </Typography>
            <br></br>
            <Typography>
                {props.occupations}: {props.occupation}
            </Typography>
          </div> */}
        </CardContent>
      </Card>
    );
  } else if (lang == "cn") {
    return (
      <Card className={classes.card}>
        <CardContent>
          <img style={{width:'30px', float:'right'}} src={redcircle}></img>
          <Typography style={{fontWeight:'bold'}}>
            {
              props.lastName_chi +
              " " +
              props.firstName_chi}
          </Typography>
          <br></br>
          <Typography>
            <a target="_blank" style={{color:'black', float:'right'}} href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${props.arbitratorId}`} >{props.arbitratorProfile}</a>
          </Typography>
        </CardContent>
      </Card>
    );
  }
};

export default withStyles(styles)(Arbitrator);
